"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.toRGBAString = exports.convertToSticky = exports.convertToHighlighter = void 0;
const chroma_js_1 = __importDefault(require("chroma-js"));
const convertToHighlighter = (color, alpha = 0.4) => (0, exports.toRGBAString)((0, chroma_js_1.default)(color).alpha(alpha));
exports.convertToHighlighter = convertToHighlighter;
const convertToSticky = (color, alpha = 0.4) => {
    const split = (0, chroma_js_1.default)(color).rgba();
    const newColor = flattenedColor(split, [255, 255, 255], alpha);
    return (0, exports.toRGBAString)(newColor);
};
exports.convertToSticky = convertToSticky;
const toRGBAString = (chroma) => {
    const chromaColor = Array.isArray(chroma) ? chroma : chroma.rgba();
    return `rgba(${chromaColor[0]}, ${chromaColor[1]}, ${chromaColor[2]}, ${chromaColor[3]})`;
};
exports.toRGBAString = toRGBAString;
const flattenedColor = (fgCol, bgCol, alpha) => [
    alpha * fgCol[0] + (1 - alpha) * bgCol[0],
    alpha * fgCol[1] + (1 - alpha) * bgCol[1],
    alpha * fgCol[2] + (1 - alpha) * bgCol[2],
    1,
];
